<app-navbar role="navigation" />
<p-confirmDialog
  role="dialog"
  [style]="{ width: '90vw', maxWidth: '420px' }"
  class="custom-confirm-dialog"></p-confirmDialog>
<p-toast position="bottom-left" [life]="3000"></p-toast>
<app-loader role="main">
  <router-outlet />
</app-loader>
